/**
 * Builder
 */
export interface Builder<T> {
    /**
     * build
     */
    build(): T;
}
